/**
 * Countdown Timer Script
 * Handles countdown functionality for campaign sections
 */

document.addEventListener('DOMContentLoaded', () => {
  const countdownElements = document.querySelectorAll('[data-countdown-end]');
  
  countdownElements.forEach((element) => {
    const endDateTime = new Date(element.getAttribute('data-countdown-end')).getTime();
    
    // Check if the date is valid
    if (isNaN(endDateTime)) {
      element.innerHTML = 'Invalid date';
      return;
    }
    
    function updateCountdown() {
      const now = new Date().getTime();
      const timeRemaining = endDateTime - now;
      
      if (timeRemaining > 0) {
        const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
        
        // Format numbers to always show 2 digits
        const formatNumber = (num) => num.toString().padStart(2, '0');
        
        // Create HTML structure with individual digit boxes
        const countdownHTML = `
          <div class="countdown-unit">
            <div class="countdown-digits">
              <div class="countdown-digit">${formatNumber(days).charAt(0)}</div>
              <div class="countdown-digit">${formatNumber(days).charAt(1)}</div>
            </div>
            <div class="countdown-label">Days</div>
          </div>
          <div class="countdown-unit">
            <div class="countdown-digits">
              <div class="countdown-digit">${formatNumber(hours).charAt(0)}</div>
              <div class="countdown-digit">${formatNumber(hours).charAt(1)}</div>
            </div>
            <div class="countdown-label">Hours</div>
          </div>
          <div class="countdown-unit">
            <div class="countdown-digits">
              <div class="countdown-digit">${formatNumber(minutes).charAt(0)}</div>
              <div class="countdown-digit">${formatNumber(minutes).charAt(1)}</div>
            </div>
            <div class="countdown-label">Minutes</div>
          </div>
          <div class="countdown-unit">
            <div class="countdown-digits">
              <div class="countdown-digit">${formatNumber(seconds).charAt(0)}</div>
              <div class="countdown-digit">${formatNumber(seconds).charAt(1)}</div>
            </div>
            <div class="countdown-label">Seconds</div>
          </div>
        `;
        
        element.innerHTML = countdownHTML;
      } else {
        // Campaign has ended
        element.innerHTML = '<div class="countdown-ended">Campaign has ended</div>';
        element.classList.add('countdown-ended');
      }
    }
    
    // Update immediately and then every second
    updateCountdown();
    const intervalId = setInterval(updateCountdown, 1000);
    
    // Store interval ID for potential cleanup
    element.setAttribute('data-countdown-interval', intervalId);
  });
});

// Optional: Cleanup function for when elements are removed
function cleanupCountdownTimers() {
  const countdownElements = document.querySelectorAll('[data-countdown-interval]');
  countdownElements.forEach((element) => {
    const intervalId = element.getAttribute('data-countdown-interval');
    if (intervalId) {
      clearInterval(parseInt(intervalId));
    }
  });
}